import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";
import { motion } from "framer-motion";
import Navigation from "../Navigation";
import Header from "../Header";
import {
  getDiagnosticModalTitle,
  getDiagnosticModalComponentBasedOnPage,
} from "../../../e-learning-display/helper/diagnosticTutorialData";
import EntryTutorialModal from "../../../e-learning-display/components/steps/partial/EntryTutorialModal";
import {postInitEvent} from "../../../util/actions/saveCustomEvent";

const SelectGoalPage = ({
  diagnosticQuestionsTutorial,
  setDiagnosticQuestionsTutorial,
  page,
  setPage,
  goals,
  selectedGoalId, // Zamiast tablicy selectedGoalIds, używamy pojedynczej wartości selectedGoalId
  setSelectedGoalId,
  name,
  playerId,
}) => {
  history.pushState(null, null, location.href);
  window.onpopstate = function () {
    history.go(1);
  };

  const toggleWantsMoreTutorialModal = () => {
    setDiagnosticQuestionsTutorial(false);
    window.localStorage.setItem("diagnosticQuestionsTutorial", "true");
  };

  const handleSelectItem = (goalId) => {
    // Wybór celu ograniczony do jednego, więc ustawiamy selectedGoalId na nowo wybrany goalId
    setSelectedGoalId(goalId);
  };

  useEffect(() => {
    if (playerId > 0) {
      postInitEvent("GOAL_SELECTION",null,null,playerId)
    }
  }, [playerId]);

  useEffect(() => {
    const temporarySavedTutorialData = window.localStorage.getItem(
      "diagnosticQuestionsTutorial"
    );

    if (
      !temporarySavedTutorialData &&
      !diagnosticQuestionsTutorial &&
      name === "testnowejsciezki"
    ) {
      setTimeout(() => {
        setDiagnosticQuestionsTutorial(true);
      }, 500);
    }
  }, []);

  return (
    <ViewContainer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <EntryTutorialModal
        showState={diagnosticQuestionsTutorial}
        toggleInformationModal={toggleWantsMoreTutorialModal}
        getComponent={getDiagnosticModalComponentBasedOnPage}
        getTitle={getDiagnosticModalTitle}
        pages={1}
      />
      <Header />
      <Content>
        <Logo>
          <img src="/assets/front/img/edustrada/logo-with-text.png" />
        </Logo>
        <TextContent>
          <Text>Świetnie {name}!</Text>
          <SmallText>Który obszar najbardziej chcesz rozwijać?</SmallText>
        </TextContent>
        <SelectBoxContainer>
        {goals.map((item, index) => (
          <SelectBox
            key={index}
            onClick={() => handleSelectItem(item.id)} // Przekazujemy goalId
            isSelected={selectedGoalId === item.id} // Sprawdzamy, czy goalId jest równy selectedGoalId
          >
            {item.name}
          </SelectBox>
        ))}
      </SelectBoxContainer>
      <Navigation
        showBackButton={false}
        showNextButton={!!selectedGoalId}
        setPage={setPage}
        page={page}
        nextButtonCallback={() => {
          postInitEvent('GOAL_SELECTION', {
            selectedGoalId: selectedGoalId,
            goals: goals,
            question: "Który obszar najbardziej chcesz rozwijać?"
          }, {goal: goals.find(g => g.id === selectedGoalId)}, playerId)
        }
        }
      />
      </Content>
    </ViewContainer>
  );
};

export default SelectGoalPage;

const ViewContainer = styled(motion.div)`
  min-height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const Logo = styled.div`
  display: flex;
  justify-content: center;
`;

const Content = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 40px 0 30px 0;
`;

const Text = styled.div`
  text-align: center;
  color: #fff;
  font-size: 20px;
  line-height: 35px;
  font-weight: 300;
`;

const SmallText = styled(Text)`
  font-size: 20px;
  line-height: 25px;
`;

const SelectBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  width: 100%;
`;

const growAnimation = keyframes`
 0% { scale: 0.9 }
 100% { scale: 1 }
`;

const SelectBox = styled.div`
  width: 100%;
  background-color: ${(props) =>
    props.isSelected ? "rgba(0, 0, 0, 0.5)" : "rgba(57,56,146,0.8)"};
  padding: 15px;
  border-radius: 15px;
  text-align: center;
  color: #fff;
  font-size: 17px;
  font-weight: 300;
  transition: all 0.2s;
  animation: ${growAnimation} 0.5s ease;

  &:active {
    transform: scale(0.97);
  }
`;
